/* eslint-disable no-nested-ternary */
import React, { useEffect } from 'react';
import { withRouter } from 'react-router-dom';
import _ from 'lodash';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import emptyStateImage from 'assets/img/icn-empty-state.svg';
import ConfirmAlert from 'modules/common/components/ConfirmAlert';
import * as actions from '../action';
import * as c from '../constant';

function BarangayUserManagementContent({
  userManagementId,
  showUserManagement,
  userManagementInfo,
  approveTransaction,
  isLoading,
}) {
  useEffect(() => {
    if (_.isEmpty(userManagementId)) return;
    showUserManagement(userManagementId);
  }, []);
  useEffect(() => {
    if (_.isEmpty(userManagementId)) return;
    showUserManagement(userManagementId);
  }, [userManagementId]);

  const handleApprove = (data) => (e) => {
    e.preventDefault();
    const args = {};
    ConfirmAlert(
      'Are you sure you want to approve this transaction?',
      () => {
        approveTransaction(_.get(data, 'id'), args, () => {
          showUserManagement(_.get(data, 'id'));
        });
      },
      () => {},
      {
        yesLabel: 'Confirm',
        noLabel: 'Cancel',
      },
      false
    );
  };

  return (
    <div className="container-fluid card-section-content">
      {!_.isEmpty(userManagementInfo) ? (
        <React.Fragment>
          <div className="card">
            <div className="card-body">
              <div className="d-flex justify-content-between align-items-center">
                <h3 className="mb-0">Account Information</h3>
                <div>
                  <button
                    disabled={_.get(userManagementInfo, 'attributes.is_active')}
                    type="button"
                    className="btn btn-success btn-round font-weight-bold"
                    onClick={handleApprove(userManagementInfo)}
                  >
                    {isLoading ? (
                      <i className="fa fa-spin fa-spinner" />
                    ) : _.get(userManagementInfo, 'attributes.is_active') ? (
                      'Account Active'
                    ) : (
                      'Activate'
                    )}
                  </button>
                </div>
              </div>
              <hr />
              <div className="mt-4">
                <div className="row d-flex justify-content-center">
                  <div className="col">
                    <table className="table table-striped table-borderless">
                      <tbody>
                        <tr>
                          <th className="table-title">Full Name:</th>
                          <td>
                            {_.get(
                              userManagementInfo,
                              'attributes.full_name'
                            ) || '--'}
                          </td>
                        </tr>

                        <tr>
                          <th className="table-title">Email Address:</th>
                          <td>
                            {_.get(userManagementInfo, 'attributes.email') ||
                              '--'}
                          </td>
                        </tr>
                        <tr>
                          <th className="table-title">Mobile Number:</th>
                          <td>
                            {_.get(
                              userManagementInfo,
                              'attributes.mobile_number'
                            ) || '--'}
                          </td>
                        </tr>

                        <tr>
                          <th className="table-title">District:</th>
                          <td>
                            {_.get(
                              userManagementInfo,
                              'attributes.district_number'
                            ) || '--'}
                          </td>
                        </tr>
                        <tr>
                          <th className="table-title">Zone:</th>
                          <td>
                            {_.get(
                              userManagementInfo,
                              'attributes.zone_number'
                            ) || '--'}
                          </td>
                        </tr>
                        <tr>
                          <th className="table-title">Barangay:</th>
                          <td>
                            {_.get(
                              userManagementInfo,
                              'attributes.barangay_number'
                            ) || '--'}
                          </td>
                        </tr>
                        <tr>
                          <th className="table-title">Barangay Chairman:</th>
                          <td>
                            {_.get(
                              userManagementInfo,
                              'attributes.chairman_name'
                            ) || '--'}
                          </td>
                        </tr>
                        <tr>
                          <th className="table-title">Message Request:</th>
                          <td>
                            {_.get(
                              userManagementInfo,
                              'attributes.message_request'
                            ) || '--'}
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </React.Fragment>
      ) : (
        <div className="d-flex align-items-center justitfy-content-center h-100">
          <div className="text-center mx-auto py-4">
            <img
              src={emptyStateImage}
              className="img-responsive image-wrapper mb-4 mt-3"
              alt="Empty State"
            />
            <p className="emp-title mb-0"> No Item Found </p>
          </div>
        </div>
      )}
    </div>
  );
}

BarangayUserManagementContent.propTypes = {
  isLoading: PropTypes.bool.isRequired,
  showUserManagement: PropTypes.instanceOf(Function).isRequired,
  approveTransaction: PropTypes.instanceOf(Function).isRequired,
  userManagementInfo: PropTypes.instanceOf(Object).isRequired,
  userManagementId: PropTypes.string.isRequired,
};

const mapStateToProps = ({ api }, { match }) => ({
  userManagementInfo: _.get(api, `${c.GET_SINGLE_USER_MANAGEMENT}.item`) || {},
  userManagementId: _.get(match, 'params.userManagementId') || '',
  isLoading: api.loading.indexOf(c.APPROVE_TRANSACTION) > -1,
});

const enhance = _.flowRight([withRouter, connect(mapStateToProps, actions)]);

export default enhance(BarangayUserManagementContent);
